import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Dropdown, DropDownItem, MenuProps } from '../../../../components/DropDown';
import { TableRowItemData } from '../../../../components/Table';
import { useAppDispatch } from '../../../../hooks/useRedux';
import ModalContainer, { ConfirmationBox } from '../../../../components/Modal';
import dayjs from 'dayjs';
import StatusChip from '../../../../components/StatusChip';
import { LPlan } from '../../../../interfaces/Plan';

export function TableRowItem({ plan }: { plan: LPlan }) {
  const [statusOptions, setStatusOptions] = useState<MenuProps[]>([]);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   let items: MenuProps[] = [];
  //   if (plan.status === 'pending') {
  //     items = [
  //       {
  //         key: 1,
  //         label: (
  //           <ModalContainer
  //             ModalComp={
  // <ConfirmationBox
  //   loading={loading}
  //   text='Confirm Cancel this plan?'
  //   onConfirm={(closeModal: () => any) => {
  //     dispatch(
  //       updatePlanStatus({
  //         _id: plan._id,
  //         data: {
  //           status: 'cancelled',
  //         },
  //       }),
  //     ).then(() => {
  //       toast.success('Plan Cancelled');
  //       closeModal();
  //     });
  //   }}
  // />
  // }
  //         >
  //           <DropDownItem label="Cancel" onClick={() => {}} />
  //         </ModalContainer>
  //       )
  //     }
  //   ];
  //   setStatusOptions(items);
  //   return;
  // }
  // if (plan.status === 'active') {
  //   items = [
  //     {
  //       key: 1,
  //       label: (
  //         <ModalContainer
  //           ModalComp={
  // <ConfirmationBox
  //   loading={loading}
  //   text='Confirm Cancel this plan?'
  //   onConfirm={(closeModal: () => any) => {
  //     dispatch(
  //       updatePlanStatus({
  //         _id: plan._id,
  //         data: {
  //           status: 'cancelled',
  //         },
  //       }),
  //     ).then(() => {
  //       toast.success('Plan Cancelled');
  //       closeModal();
  //     });
  //   }}
  // />
  //             }
  //           >
  //             <DropDownItem label="Cancel" onClick={() => {}} />
  //           </ModalContainer>
  //         )
  //       }
  //     ];
  //     setStatusOptions(items);
  //     return;
  //   }
  // }, [plan.status]);

  return (
    <>
      <TableRowItemData
        onClick={() => navigate(`${plan._id}`)}
        text={`${dayjs(plan.createdAt).format('DD/MM/YYYY')}`}
      />
      <TableRowItemData onClick={() => navigate(`${plan._id}`)} text={plan._id} />
      <TableRowItemData onClick={() => navigate(`${plan._id}`)} text={plan.user ? plan.user.name : ''} />
      <TableRowItemData onClick={() => navigate(`${plan._id}`)} text={plan.user ? plan.user.email : ''} />
      <TableRowItemData onClick={() => navigate(`${plan._id}`)} text={plan.user ? plan.user.phoneNumber : ''} />
      <TableRowItemData onClick={() => navigate(`${plan._id}`)} text={plan.totalSessions.toString()} />
      <TableRowItemData
        component={
          <div className="w-full flex items-center justify-between">
            {/* <Dropdown menu={statusOptions} placement="bottomLeft"> */}
            <StatusChip
              expand={false}
              state={
                plan.changeRequest?.status === 'approved'
                  ? 'success'
                  : plan.changeRequest?.status === 'rejected'
                    ? 'error'
                    : 'pending'
              }
            >
              <p className="font-semibold text-[11px] w-24">
                {plan.changeRequest?.status === 'pending'
                  ? 'NEW'
                  : plan.changeRequest?.status === 'approved'
                    ? 'ACCEPTED'
                    : 'REJECTED'}
              </p>
            </StatusChip>
            {/* </Dropdown> */}
          </div>
        }
      />
    </>
  );
}

// ${plan.status === 'change-request' && 'bg-[#808286]'}
